import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { recentBuyers, MOCKUP_URL } from '../data/content';
type Notice = {
  name: string;
  country: string;
  minutes: number;
};
const FIRST_DELAY = 5000;
const SHOW_FOR = 5000;
const GAP = 9000;
export function PurchasePopup() {
  const [notice, setNotice] = useState<Notice | null>(null);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let index = Math.floor(Math.random() * recentBuyers.length);
    let hideTimer: number;
    let nextTimer: number;
    const show = () => {
      const buyer = recentBuyers[index % recentBuyers.length];
      index += 1 + Math.floor(Math.random() * 3);
      setNotice({
        ...buyer,
        minutes: 1 + Math.floor(Math.random() * 14)
      });
      hideTimer = window.setTimeout(() => {
        setNotice(null);
        nextTimer = window.setTimeout(show, GAP);
      }, SHOW_FOR);
    };
    nextTimer = window.setTimeout(show, FIRST_DELAY);
    return () => {
      window.clearTimeout(hideTimer);
      window.clearTimeout(nextTimer);
    };
  }, [dismissed]);
  return <div className="pointer-events-none fixed inset-x-3 bottom-[104px] z-50 sm:inset-x-auto sm:left-5 sm:w-[360px]" aria-live="polite" data-id="element-261" data-mp="1fwbzi2hzbctj">
      <AnimatePresence data-id="element-262" data-mp="1ax7nl43o70zi">
        {notice && !dismissed && <motion.div key={`${notice.name}-${notice.minutes}`} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex items-center gap-3 rounded-2xl bg-white p-3 pr-9 text-ink shadow-2xl ring-1 ring-black/5" data-id="element-263" data-mp="n6linloypwtq">
            <img src={MOCKUP_URL} alt="" className="h-14 w-14 shrink-0 rounded-lg bg-navy object-contain p-0.5" data-id="element-264" data-mp="28manrvocn5x5" />
            <div className="min-w-0" data-id="element-265" data-mp="2aotio8qhnng1">
              <p className="text-sm leading-snug" data-id="element-266" data-mp="2anrxhbfrdkkl">
                <strong data-id="element-267" data-mp="2fnnzj54wb1xi">{notice.name}</strong> from <strong data-id="element-268" data-mp="2fmmp92vpejgu">{notice.country}</strong> just purchased the
                Parasitic Drain Diagnostic Blueprint™
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-emerald-700" data-id="element-269" data-mp="2kko6rjdheaq7">
                <ShoppingBagIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-270" data-mp="2pjrbt3tgogy6" />
                {notice.minutes} min ago • Verified purchase
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-slate-500 transition-colors duration-150 hover:bg-slate-100 hover:text-ink" aria-label="Dismiss purchase notifications" data-id="element-271" data-mp="1wxy4qi14ug5l">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-272" data-mp="197c1d422pk1x" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}